//  POEdit.aspx -> Create Product
var InitCreateProductModal = function (poEdit, $) {
    poEdit.CreateProductModal = (function () {
        const SubmitBtnSelector = '#createProductBtn'
        const CloseBtnSelector = '#product_create_close_modal_btn'
        const AdditionalDetailsBtnSelector = '#product_create_additional_details_btn'
        const BackToMainBtnSelector = '#product_create_back_to_main_btn'
        const AccessDeniedModalSelector = '#access_restricted_modal'
        const AccessDeniedCreateProductAttributeModalSelector = '#create_product_attribute_access_restricted'
        const ModalSelector = '#create_product_modal'
        const SupplierBuySelector = '#create_product_supplierbuy_ex'
        const SupplierBuyTitleSelector = '#create_product_supplierbuy_ex_title'
        const BuyExSelector = '#create_product_buy_ex'
        const DirectCostsSelector = '#create_product_direct_costs'
        const CogsSelector = '#create_product_cogs'
        const OrderQtySelector = '#create_product_order_qty'
        const SellPriceFixedSelector = '#create_product_sell_price_fixed'
        const PriceMarkupSelector = '#create_product_price_markup'
        const DefaultTaxRateSelector = '#default_tax_rate'
        const RoundMarkupTargetPricesBySelector = '#round_markup_target_prices_by'
        const CalcSellPriceMarkupSelector = '#calc_sell_price_markup'
        const OrderTotalSelector = '#create_product_order_total'
        const ProductShortDescriptionSelector = '#create_product_short_desc'
        const ProductSeasonSelector = '#create_product_season'
        const ProductSizeSelector = '#create_product_size'
        const ProductColourSelector = '#create_product_colour'
        const ProductTypeSelector = '#create_product_product_type'
        const ProductBrandSelector = '#create_product_brand'
        const ManufacturerSkuSelector = '#create_product_manufacturer_sku'
        const SkuSelector = '#create_product_supplier_sku'
        const GenerateSkuSelector = '#create-product-prefill-sku'
        const RadioBtnsSellPriceOptionSelector = 'input[name=SellPriceOptionRadio]'
        const CalcSellPriceFixedRadioSelector = '#calc_sell_price_fixed'
        const ModalTooltipsSelector = ModalSelector + ' ' + '.bspopover'
        const MarkTargetTip = '#mark-target-tip'
        const MainStep = '.create_product_main_step'
        const AdditionalStep = '.create_product_additional_step'
        const AdditionalStepBlock = '#create_product_additional_step_block'

        //additional details selectors
        const SupplierSKU2 = '#create_product_supplier_sku2';
        const Custom1 = '#create_product_custom1';
        const Custom2 = '#create_product_custom2';
        const Custom3 = '#create_product_custom3';
        const Weight = '#create_product_weight';
        const Length = '#create_product_length';
        const Breadth = '#create_product_breadth';
        const Depth = '#create_product_depth';
        const ShippingCubic = '#create_product_shipping_cubic';
        const RequireSerialNumber = '#create_product_serial_number';
        const Disabled = '#create_product_disabled';
        const RRP = '#create_product_rrp';
        const WebPrice = '#create_product_web_price';
        const CustomAttributesTable = '#product_create_custom_attributes_table';
        const ShopifyChannelsTable = '#product_create_publish_to_shopify_table';

        // outside the modal window
        const ProductOrderIdSelector = '#tbxPOID'
        const ProductSupplierSelector = '#ddlSupplier'

        var quickCreateProductEnhancementsFeatureEnabled = false;

        //any decimal value and 0
        var regExMoney = new RegExp("^([0-9]+(?:[.][0-9]*)?|[.][0-9]+)$");

        // Rounds resultPrice to nearest POS_RoundMarkupTargetPricesBy (matches ProdEdit.asp
        var roundPriceByMarkupTarget = function (resultPrice) {
            var roundToNearest = parseFloat($(RoundMarkupTargetPricesBySelector).val());
            if (isNaN(roundToNearest) || roundToNearest <= 0) {
                return Math.round(resultPrice * 100) / 100;
            }
            return Math.round(resultPrice / roundToNearest) * roundToNearest;
        };

        var calculatePriceByMarkup = function () {
            var supplierPrice = parseFloat($(SupplierBuySelector).val())

            if ($(CalcSellPriceMarkupSelector).get(0).checked === true) {
                var priceMarkup = $(PriceMarkupSelector).val();

                if (priceMarkup == '') {
                    $(SellPriceFixedSelector).val('')
                }
                else {
                    var resultPrice = supplierPrice + supplierPrice * parseFloat(priceMarkup) * 0.01;
                    var defaultTaxRate = $(DefaultTaxRateSelector).val();
                    if (defaultTaxRate != '') {
                        resultPrice = resultPrice + resultPrice * parseFloat(defaultTaxRate);
                    }
                    $(SellPriceFixedSelector).val(roundPriceByMarkupTarget(resultPrice).toFixed(2));
                }
            }

            var orderQty = parseInt($(OrderQtySelector).val())
            if (supplierPrice && orderQty) {
                $(OrderTotalSelector).val('$' + (supplierPrice * orderQty).toFixed(2))
            }
        }

        var adjustCalculatedValues = function () {
            // cogs
            var cogsValue = parseFloat(($(BuyExSelector).val() || 0)) + parseFloat(($(DirectCostsSelector).val() || 0))
            $(CogsSelector).val(cogsValue.toFixed(2));

            // sell price
            if ($(CalcSellPriceMarkupSelector).get(0).checked === true) {
                var priceMarkup = $(PriceMarkupSelector).val();

                if (priceMarkup == '') {
                    $(SellPriceFixedSelector).val('')
                }
                else {
                    var resultPrice = cogsValue + cogsValue * parseFloat(priceMarkup) * 0.01;
                    var defaultTaxRate = $(DefaultTaxRateSelector).val();
                    if (defaultTaxRate != '') {
                        resultPrice = resultPrice + resultPrice * parseFloat(defaultTaxRate);
                    }
                    $(SellPriceFixedSelector).val(roundPriceByMarkupTarget(resultPrice).toFixed(2));
                }
            }

            // total order qty
            var buyEx = parseFloat($(BuyExSelector).val())
            var orderQty = parseInt($(OrderQtySelector).val())
            if (buyEx && orderQty) {
                $(OrderTotalSelector).val('$' + (buyEx * orderQty).toFixed(2))
            }
        }

        var overrideBuyEx = function () {
            var newVal = parseFloat($(SupplierBuySelector).val());
            if (isNaN(newVal)) {
                $(BuyExSelector).val(null);
            }
            if (newVal >= 0) {
                $(BuyExSelector).val(newVal);
            }
            adjustCalculatedValues();
        }

        var onSellPriceOptionRadioCheck = function (e) {
            if ($(CalcSellPriceMarkupSelector).get(0).checked === true) {
                $(PriceMarkupSelector).prop('disabled', false)
                $(SellPriceFixedSelector).prop('disabled', true)
            }
            else {
                $(PriceMarkupSelector).prop('disabled', true)
                $(SellPriceFixedSelector).prop('disabled', false)
            }

            if (quickCreateProductEnhancementsFeatureEnabled) {
                adjustCalculatedValues();
            } else {
                calculatePriceByMarkup();
            }
        }

        var validateModal = function () {
            var msg = ''
            msg += $(ProductShortDescriptionSelector).val() ? '' : 'You must enter a Short Description (Product Name)\n'
            msg += $(SkuSelector).val() ? '' : 'You must specify a Supplier SKU\n'
            msg += $(SkuSelector).val().length > 50 ? "Supplier SKU length can't be more than 50.\n" : ''
            msg += $(ProductTypeSelector).val() ? '' : 'You must specify a Product Type\n'

            

            if (quickCreateProductEnhancementsFeatureEnabled) {

                if ($(BuyExSelector).val() === "") {
                    msg += "You must enter a Buy Ex\n";
                } else if (!regExMoney.test($(BuyExSelector).val())) {
                    msg += "Buy Ex must be a positive number\n";
                } else if ($(BuyExSelector).val() > 99999999999999) {
                    msg += "Invalid Buy Ex - Exceeds Maximum Supported Value\n"
                }

                if ($(DirectCostsSelector).val()) {
                    if (!regExMoney.test($(DirectCostsSelector).val())) {
                        msg += "Direct Costs must be a positive number\n";
                    }
                    else if ($(DirectCostsSelector).val() > 99999999999999) {
                        msg += "Invalid Direct Costs - Exceeds Maximum Supported Value\n"
                    }
                }

            } else {
                msg += $(SupplierBuySelector).val() ? '' : 'You must enter a Supplier Buy Ex\n'
            }

            if ($(SupplierBuySelector).val() && !regExMoney.test($(SupplierBuySelector).val())) {
                msg += "Supplier Buy Ex must be a positive number\n";
            }
            msg += $(SellPriceFixedSelector).val() ? '' : 'You must enter a Sell Price Inc\n'
            msg += $(OrderQtySelector).val() ? '' : 'You must enter a Order Quantity\n'

            if ($(SellPriceFixedSelector).val() && !regExMoney.test($(SellPriceFixedSelector).val())) {
                msg += "Sell Price Inc must be a positive number\n";
            }

            if ($(OrderQtySelector).val() && !regExMoney.test($(OrderQtySelector).val())) {
                msg += "Order Quantity must be a positive number\n";
            }

            if ($(RRP).val() && !regExMoney.test($(RRP).val())) {
                msg += "RRP must be a positive number\n";
            }           

            if ($(WebPrice).val() && !regExMoney.test($(WebPrice).val())) {
                msg += "Web Price must be a positive number\n";
            }
            
            BackOffice.Utils.CheckUniqueSKU($(SkuSelector).val(), null, $(SkuSelector).attr('id'), true, false, function () {
                var nonUniqueMessage = 'Supplier SKU must be unique (entered value matches existing Supplier SKU or Barcode)\n';
                msg += ($(SkuSelector).get(0).IsUnique === 'true' || $(SkuSelector).val() === '') ? '' : nonUniqueMessage
            });

            if (msg) {
                alert(msg)
            }
            return msg == ''
        }

        var submitModal = function (e) {
            if (validateModal()) {
                
                function getAttribute(id, selector){
                    return {
                        Id: id,
                        Value: {
                            Id: parseInt($(selector).val()) || null
                        }
                    };
                }

                var cogsValue = quickCreateProductEnhancementsFeatureEnabled ? parseFloat($(CogsSelector).val()) : parseFloat($(SupplierBuySelector).val());
                var buyExValue = quickCreateProductEnhancementsFeatureEnabled ? parseFloat(($(BuyExSelector).val() || 0)) : null;
                var directCostsValue = quickCreateProductEnhancementsFeatureEnabled ? parseFloat(($(DirectCostsSelector).val() || 0)) : null;

                var product = {
                    ShortDescription: $(ProductShortDescriptionSelector).val(),
                    SupplierSku: $(SkuSelector).val(),
                    Supplier: { SupplierCode: $(ProductSupplierSelector).val() },
                    ProductType: { Id: $(ProductTypeSelector).val() },
                    ManufacturerSku: $(ManufacturerSkuSelector).val(),
                    Attributes: [],
                    SupplierBuyEx: $(SupplierBuySelector).val(),
                    SellPrice: $(SellPriceFixedSelector).val(),
                    MarkupTarget: parseFloat($(PriceMarkupSelector).val()) || null,
                    CogsEx: cogsValue || null,
                    BuyPriceEx: buyExValue,
                    DirectCosts: directCostsValue
                };

                //brand, season, size, colour
                var systemAttriutes = [{Attribute: poEdit.ProductAttributeEnum.Brand, Value: ProductBrandSelector},
                    {Attribute: poEdit.ProductAttributeEnum.Season, Value: ProductSeasonSelector},
                    {Attribute: poEdit.ProductAttributeEnum.Size, Value: ProductSizeSelector},
                    {Attribute: poEdit.ProductAttributeEnum.Colour, Value: ProductColourSelector}];

                for(var i = 0; i < systemAttriutes.length; i++){
                    var attribute  = getAttribute(systemAttriutes[i].Attribute, systemAttriutes[i].Value);
                    if(attribute.Value.Id != null){
                        product.Attributes.push(attribute);
                    }
                }

                if (quickCreateProductEnhancementsFeatureEnabled) {
                    var selectedCustomAttributes = readSelectedCustomAttributes();
                    var selectedSalesChannels = readSelectedShopifyChannels();

                    product.SupplierSku2 = $(SupplierSKU2).val() || null;
                    product.CustomProperties = [
                        {
                            Name: 'Custom1',
                            Value: $(Custom1).val() || null,
                        },
                        {
                            Name: 'Custom2',
                            Value: $(Custom2).val() || null,
                        },
                        {
                            Name: 'Custom3',
                            Value: $(Custom3).val() || null,
                        },
                    ];
                    product.Weight = $(Weight).val() || null;
                    product.Length = $(Length).val() || null;
                    product.Breadth = $(Breadth).val() || null;
                    product.Depth = $(Depth).val() || null;
                    product.ShippingCubic = $(ShippingCubic).val() || null;
                    product.RequireSerialNumber = $(RequireSerialNumber).val() || null;
                    product.Disabled = $(Disabled)[0].checked;
                    product.RrpInc = $(RRP).val() || null;
                    product.WebPrice = $(WebPrice).val() || null;
                    product.Attributes = product.Attributes.concat(selectedCustomAttributes);
                    product.SalesChannels = selectedSalesChannels;
                }
                
                var productData=JSON.stringify([product])
                $.ajax({
                    method: 'POST',
                    async: false,
                    data: productData,
                    url: window.location.origin + '/dotnet/admin/api/createproducts',
                    dataType: 'json',
                    contentType: 'application/json charset=UTF-8',
                    success: function () {
                        $.ajax({
                            url: window.location.origin + '/dotnet/admin/api/getproductbysku',
                            dataType: 'json',
                            async: false,
                            data: { "sku": $(SkuSelector).val() },
                            contentType: 'application/json; charset=UTF-8',
                            success: function (data) {
                                $.ajax({
                                    method: 'POST',
                                    async: false,
                                    data: JSON.stringify({
                                        PoId: $(ProductOrderIdSelector).val(),
                                        PoItems: [{
                                            ProductId: data.id,
                                            Qty: $(OrderQtySelector).val(),
                                            SupplierBuy: quickCreateProductEnhancementsFeatureEnabled ? $(BuyExSelector).val() : $(SupplierBuySelector).val()
                                        }]
                                    }),
                                    url: window.location.origin + '/dotnet/admin/api/addproductstopo',
                                    dataType: 'json',
                                    contentType: 'application/json charset=UTF-8',
                                    success: function () {
                                        $(ModalSelector).modal('hide')
                                        return true;
                                    }
                                })
                            }
                        });
                    }
                })
            }
            else {
                return false
            }
        }

        var loadProductOption = function (url, callback){
            $.ajax({
                url: url,
                dataType: 'json',
                contentType: 'application/json charset=UTF-8',
                success: callback
            });
        }

        var fillDropDown = function (selector, dataArray) {
            for (var i = 0; i < dataArray.length; i++) {
                $('<option/>', {
                    value: dataArray[i].id,
                    html: dataArray[i].name,
                }).appendTo(selector);

                $(selector + " option:last")[0].setAttribute('data-sortOrder', dataArray[i].listOrder);
            }

            sortDropDown(selector);
            $(selector).prop("selectedIndex", 0);
        }

        var sortDropDown = function (selector) {
            $(selector).html($(selector + " option").sort(function (a, b) {
                var aSortOrder = parseInt(a.getAttribute('data-sortOrder'));
                var bSortOrder = parseInt(b.getAttribute('data-sortOrder'));

                aSortOrder = isNaN(aSortOrder) ? null : aSortOrder;
                bSortOrder = isNaN(bSortOrder) ? null : bSortOrder;

                if ((a.text.toUpperCase() == b.text.toUpperCase() && aSortOrder == bSortOrder) ||
                    (a.value == 'new_attr' || b.value == 'new_attr') || (a.value == '' || b.value == '')) {
                    return 0;
                }

                if ((aSortOrder == null && bSortOrder != null) || aSortOrder > bSortOrder) {
                    return 1;
                }

                if (aSortOrder < bSortOrder) {
                    return -1;
                }

                return a.text.toUpperCase() < b.text.toUpperCase() ? -1 : 1; 
            }))
        }

        var closeModal = function () {
            $(ProductShortDescriptionSelector).val('')
            $(SkuSelector).val('')
            $(ManufacturerSkuSelector).val('')
            $(OrderQtySelector).val('')
            $(SupplierBuySelector).val('')
            $(SellPriceFixedSelector).val('')
            $(PriceMarkupSelector).val('')
            $(OrderTotalSelector).val('')
            $(CalcSellPriceFixedRadioSelector).attr('checked', true)
            if (quickCreateProductEnhancementsFeatureEnabled) {
                $(BuyExSelector).val('')
                $(DirectCostsSelector).val('')
                $(CogsSelector).val('')

                $(AdditionalStepBlock + ' :input').not(':button, :submit').val('').prop('checked', false).prop('selected', false);
            }
        }

        var insertAddItem = function (selector, tagFunction) {
            $(selector).html('<option></option>');
            $('<option/>', {
                value: "new_attr",
                html: "-- Add New --"
            }).appendTo(selector);

            $(selector).change(function () {
                if ($(this).val() == "new_attr") {
                    $(selector).prop("selectedIndex", 0);
                    tagFunction(selector, function (data) {
                        fillDropDown(selector, [data]);
                        $(selector).val(data.id);
                    });
                }
            });
        }

        var showAttributeAccessDiniedModal = function() {
            $(AccessDeniedCreateProductAttributeModalSelector).modal('show');
        }

        var openMainStep = function () {
            $(ModalSelector + ' .modal-title').html('Create Product and Add to PO');
            $(AdditionalStep).attr("hidden", true);
            $(MainStep).attr("hidden", false);

            return false;
        };

        var loadAdditionalDetailsStep = function () {
            if (validateModal()) {
                openAdditionalDetailsStep();
                loadCustomAttributes();
                loadShopifyChannels();
            }

            return false;
        }

        var openAdditionalDetailsStep = function () {
            $(ModalSelector + ' .modal-title').html('Additional Details');
            $(MainStep).attr("hidden", true);
            $(AdditionalStep).attr("hidden", false);
        }

        var loadCustomAttributes = function () {
            if ($(CustomAttributesTable)[0] && $(CustomAttributesTable)[0].rows.length === 0) {
                callApi('/getproductattributes/custom',
                    null,
                    function (response) {
                        renderCustomAttributes(response);
                        registerCustomAttributeEvents(response);
                    },
                    true);
            }
        }

        var loadShopifyChannels = function () {
            if ($(ShopifyChannelsTable)[0] && $(ShopifyChannelsTable)[0].rows.length === 0) {
                callApi("shopifychannels",
                    null,
                    function (salesChannels) {
                        renderShopifyChannels(salesChannels);
                    },
                    true);
            }
        }

        var renderCustomAttributes = function (customAttributes) {
            var attributes = customAttributes || [];
            $(CustomAttributesTable).html('');
            var gridContent = '';
            for (var i = 0; i < attributes.length; i++) {
                var currentAttribute = attributes[i];
                currentAttribute.options = currentAttribute.options || [];
                gridContent += '<tr>';
                gridContent += '<td class="product-create-table-label-column"><label>' + currentAttribute.name + '</label></td>';
                gridContent += '<td class="product-create-table-value-column"><input type="hidden" value="' + currentAttribute.id + '" />';
                gridContent += '<input type="hidden" value="' + currentAttribute.name + '" />';
                gridContent += '<select id="CustomAttribute_' + currentAttribute.id + '" name="CustomAttribute_' + currentAttribute.id + '">';
                gridContent += '<option></option>';
                gridContent += '<option value="-1">-- Add New --</option>';
                for (var j = 0; j < currentAttribute.options.length; j++) {
                    gridContent += '<option value="' + currentAttribute.options[j].id + '">' + currentAttribute.options[j].name + '</option>';
                }
                gridContent += '</select></td>'
                gridContent += '</tr>';
            }

            $(CustomAttributesTable).append(gridContent);
        }

        function registerCustomAttributeEvents(customAttributes) {
            var attributes = customAttributes || [];

            for (var i = 0; i < attributes.length; i++) {
                var currentAttribute = attributes[i];

                $('#CustomAttribute_' + currentAttribute.id).change(function () {
                    if ($(this).val() == "-1") {
                        var selector = '#CustomAttribute_' + $(this).prev().prev().val();
                        $(selector).prop("selectedIndex", 0);
                        if (BackOffice.options.userPermissions.userHasProductAttributesPermission) {
                            var createCustomAttributeValueModal = BackOffice.StyleProductCreateModal.CreateAttributeModal.ShowCreateCustomAttributeValueModal;
                            var attributeName = $(selector).prev().val();
                            var attributeId = $(selector).prev().prev().val();
                            createCustomAttributeValueModal(selector, attributeName, attributeId, function (data) {
                                $('<option/>', {
                                    value: data.id,
                                    html: data.name,
                                }).appendTo(selector);

                                sortDropDown(selector);

                                $(selector).val(data.id);
                            });
                        }
                        else {
                            $(selector).val('');
                            showAttributeAccessDiniedModal();
                        }
                    }
                });
            }
        }

        var renderShopifyChannels = function (shopifyChannels) {
            var channels = shopifyChannels || [];
            $(ShopifyChannelsTable).html('');
            var gridContent = '';
            for (var i = 0; i < channels.length; i++) {
                var shopifyChannel = channels[i];
                gridContent += '<tr>';
                gridContent += '<td class="product-create-table-label-column"><label>' + shopifyChannel.name + '.myshopify.com</label></td>';
                gridContent += '<td class="product-create-shopify-value-column"><input type="checkbox" value="' + shopifyChannel.id + '" /></td>';
                gridContent += '</tr>';
            }

            $(ShopifyChannelsTable).append(gridContent);
        }

        var readSelectedCustomAttributes = function () {
            var selectedAttributes = [];
            var customAttributesTableObj = $(CustomAttributesTable)[0];
            if (customAttributesTableObj.rows.length > 0) {
                for (var j = 0; j < customAttributesTableObj.rows.length; j++) {
                    var attributeId = customAttributesTableObj.rows[j].childNodes[1].childNodes[0].value;
                    var attributeValueId = customAttributesTableObj.rows[j].childNodes[1].childNodes[2].value;
                    if (attributeId && attributeValueId) {
                        selectedAttributes.push({
                            Id: parseInt(attributeId),
                            Value: {
                                Id: parseInt(attributeValueId)
                            }
                        });
                    }
                }
            }
            return selectedAttributes;
        }

        var readSelectedShopifyChannels = function () {
            var selectedChannels = [];
            var publishToShopifyTableObj = $(ShopifyChannelsTable)[0];
            if (publishToShopifyTableObj.rows.length) {
                for (var i = 0; i < publishToShopifyTableObj.rows.length; i++) {
                    var shopifyChannelCheckboxNode = publishToShopifyTableObj.rows[i].childNodes[1].childNodes[0];
                    if (shopifyChannelCheckboxNode.checked) {
                        selectedChannels.push({ Id: shopifyChannelCheckboxNode.value, Enabled: true });
                    }
                }
            }
            return selectedChannels;
        }

        var callApi = function (endpoint, data, callback, isAsync) {
            $.ajax({
                url: window.location.origin + '/dotnet/admin/api/' + endpoint,
                dataType: 'json',
                async: isAsync,
                data: data,
                contentType: 'application/json; charset=UTF-8',
                success: callback
            });
        }

        
        var generateSKU = function () {
            var currentDateTime = new Date().toISOString().split('T');
            var date = currentDateTime[0].split('-');
            var time = currentDateTime[1].split(':');
            var skuTime = 'SKU-' + date[2] + date[1] + date[0].substr(-2) + time[0] + time[1] + time[2].slice(0, 2);
            $(SkuSelector).val(skuTime);
            $(SkuSelector).trigger('change');
        }

        var openModal = function (quickCreateProdEnhEnabled) {
            quickCreateProductEnhancementsFeatureEnabled = quickCreateProdEnhEnabled;

            if (BackOffice.options.userPermissions.userHasEditProductPermission) {

                $(SubmitBtnSelector).off('click').click(submitModal)
                $(CloseBtnSelector).off('click').click(closeModal)
                $(GenerateSkuSelector).off('click').click(generateSKU)
                $(RadioBtnsSellPriceOptionSelector).off('change').change(onSellPriceOptionRadioCheck)
                $(SubmitBtnSelector).off('keydown').keydown(function (e) {
                    if ((e.which === 9 && !e.shiftKey)) {
                        e.preventDefault();
                        $(ProductShortDescriptionSelector).focus();
                    }
                })

                if (quickCreateProductEnhancementsFeatureEnabled) {
                    $(BuyExSelector).off('keyup').keyup(adjustCalculatedValues);
                    $(DirectCostsSelector).off('keyup').keyup(adjustCalculatedValues);
                    $(OrderQtySelector).off('keyup').keyup(adjustCalculatedValues);
                    $(PriceMarkupSelector).off('keyup').keyup(adjustCalculatedValues);
                    $(SupplierBuySelector).off('keyup').keyup(overrideBuyEx);
                    $(SupplierBuyTitleSelector).removeClass('required-input');
                    $(SupplierBuySelector).trigger("keyup");
                    $(MarkTargetTip)[0].dataset.content = 'Sell Price Inc = (COGS + (COGS * (Markup % / 100))) * (1 + TaxRate)';
                    $(AdditionalDetailsBtnSelector).off('click').click(loadAdditionalDetailsStep);
                    $(BackToMainBtnSelector).off('click').click(openMainStep);
                } else {
                    $(SupplierBuySelector).off('keyup').keyup(calculatePriceByMarkup);
                    $(OrderQtySelector).off('keyup').keyup(calculatePriceByMarkup);
                    $(PriceMarkupSelector).off('keyup').keyup(calculatePriceByMarkup);
                }

                BackOffice.ToggleLoader(true);

                if (BackOffice.options.userPermissions.userHasProductTypesPermission) {
                    insertAddItem(ProductTypeSelector, poEdit.CreateProductModal.CreateAttributeModal.ShowCreateProductTypeModal);
                }
                else {
                    insertAddItem(ProductTypeSelector, showAttributeAccessDiniedModal);
                }

                if(BackOffice.options.userPermissions.userHasProductAttributesPermission) {
                    insertAddItem(ProductSeasonSelector, poEdit.CreateProductModal.CreateAttributeModal.ShowCreateSeasonModal);
                    insertAddItem(ProductColourSelector, poEdit.CreateProductModal.CreateAttributeModal.ShowCreateColourModal);
                    insertAddItem(ProductSizeSelector, poEdit.CreateProductModal.CreateAttributeModal.ShowCreateSizeModal);
                    insertAddItem(ProductBrandSelector, poEdit.CreateProductModal.CreateAttributeModal.ShowCreateBrandModal);
                }
                else {
                    insertAddItem(ProductSeasonSelector, showAttributeAccessDiniedModal);
                    insertAddItem(ProductColourSelector,showAttributeAccessDiniedModal);
                    insertAddItem(ProductSizeSelector, showAttributeAccessDiniedModal);
                    insertAddItem(ProductBrandSelector, showAttributeAccessDiniedModal);
                }

                loadProductOption(window.location.origin + '/dotnet/admin/api/getproducttypes', function (data) {   
                    fillDropDown(ProductTypeSelector, data)
                })

                loadProductOption(window.location.origin + '/dotnet/admin/api/getproductattributevalues/' + poEdit.ProductAttributeEnum.Season, function (data) {
                    fillDropDown(ProductSeasonSelector, data)
                })

                loadProductOption(window.location.origin + '/dotnet/admin/api/getproductattributevalues/' + poEdit.ProductAttributeEnum.Colour, function (data) {
                    fillDropDown(ProductColourSelector, data)
                })

                loadProductOption(window.location.origin + '/dotnet/admin/api/getproductattributevalues/' + poEdit.ProductAttributeEnum.Size, function (data) {
                    fillDropDown(ProductSizeSelector, data)
                })

                loadProductOption(window.location.origin + '/dotnet/admin/api/getproductattributevalues/' + poEdit.ProductAttributeEnum.Brand, function (data) {
                    fillDropDown(ProductBrandSelector, data)
                })

                $(document).one('ajaxStop', function () {
                    BackOffice.ToggleLoader(false);
                });

                $(ModalTooltipsSelector).popover({
                    container: ModalSelector
                })
                $(ModalSelector).modal('show')
            }
            else {
                $(AccessDeniedModalSelector).modal('show')
            }
            return false
        }

        return $.extend(poEdit.CreateProductModal, {
            OpenModal: openModal
        })
    })()
    
    InitCreateAttributeModal(poEdit.CreateProductModal, poEdit.ProductAttributeEnum, $);

    return poEdit.CreateProductModal
}